export default "__VITE_ASSET__0cb5bee2__"